import React, { useEffect, useRef, useState } from "react";
import Button from "../utils/Button";
import Toast from "../utils/Toast";

const OtpScreen = ({
  emailId,
  handleResend,
  handleVerify,
  error,
  setError,
  verificationLoader,
  handleCloseToast,
  toast,
  setToast,
}) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputsRef = useRef([]);
  const [timer, setTimer] = useState(60); // Timer for 30 seconds
  const [isTimerActive, setIsTimerActive] = useState(false);

  useEffect(() => {
    if (isTimerActive && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => clearInterval(interval);
    } else if (timer === 0) {
      setIsTimerActive(false);
    }
  }, [isTimerActive, timer]);

  const handleChange = (e, index) => {
    setError(false);

    const value = e.target.value;

    // Only allow numbers
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Focus next input
      if (value && index < 5) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e, index) => {
    setError(false);

    const pastedData = e.clipboardData.getData("Text");
    const newOtp = [...otp];

    // Populate OTP fields based on pasted data
    for (let i = 0; i < pastedData.length && i < 6; i++) {
      if (/^[0-9]$/.test(pastedData[i])) {
        newOtp[i] = pastedData[i];
      }
    }

    setOtp(newOtp);

    // Focus the next input after pasting
    if (pastedData.length > 0) {
      inputsRef.current[Math.min(pastedData.length, 5)].focus();
    }
  };

  const handleResendOtp = () => {
    // Reset timer and OTP state
    setError(false);
    handleResend();
    setOtp(Array(6).fill(""));
    setTimer(60);
    setIsTimerActive(true);
  };

  useEffect(() => {
    inputsRef.current[0].focus();
  }, []);

  return (
    <div className="flex flex-col gap-4 ">
      {/* {error && (
        <div className="bg-customError-100 ring-1 ring-customError-200 rounded-md p-3 mb-4">
          <p className="text-sm font-semibold text-customError-500">{error}</p>
        </div>
      )} */}
      <div className="flex space-x-2 justify-center">
        {otp.map((value, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            value={value}
            onInput={(e) => handleChange(e, index)}
            onPaste={(e) => handlePaste(e, index)} // Handle paste
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputsRef.current[index] = el)}
            className="w-12 h-12 text-center border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500  bg-gray-50"
          />
        ))}
      </div>
      <Button
        text="Verify OTP"
        size="md"
        loading={verificationLoader}
        onClick={() =>
          handleVerify({
            emailId: emailId,
            otp: otp,
            emailData: {
              customerName: emailId.trim().split("@")[0],
              status: "email_verification",
              emailTo: emailId,
              // emailCc: "mbosscher@scienslogistics.com",
              emailBcc: "",
            },
          })
        }
      />
      <div className="flex justify-center">
        {isTimerActive ? (
          <p className="underline text-sm text-gray-400">
            Resend in{" "}
            {timer === 60 ? `01:00` : `00:${timer > 9 ? timer : "0" + timer}`}
          </p>
        ) : (
          <p
            className="text-primary-500 text-sm underline cursor-pointer"
            onClick={() => handleResendOtp()}
          >
            Resend
          </p>
        )}
      </div>
      {toast?.isOpen && (
        <Toast
          message={toast?.message}
          isVisible={toast?.isOpen}
          onClose={handleCloseToast}
        />
      )}
    </div>
  );
};

export default OtpScreen;
